import { Contractor } from "./data";

interface HireConfirmationModalProps {
  contractor: Contractor;
  hiring?: boolean;
  onConfirmHire: () => void;
  onClose: () => void;
}

export function HireConfirmationModal({
  contractor,
  hiring = false,
  onConfirmHire,
  onClose,
}: HireConfirmationModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 suggested-contractors-modal"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg rounded-lg border border-border bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-b border-border px-6 py-4">
          <div className="flex items-start justify-between">
            <div>
              <div className="mb-1 text-foreground text-[15px] font-[500]">Confirm Hiring</div>
              <div className="text-muted-foreground">
                Start the hiring process with this contractor
              </div>
            </div>
            <button
              onClick={onClose}
              className="rounded-lg bg-transparent border-0 px-3 py-1 text-foreground hover:bg-accent"
            >
              ✕
            </button>
          </div>
        </div>

        <div className="px-6 py-6">
          <div className="mb-6 flex items-center gap-4 rounded-lg border border-border bg-muted/30 p-4">
            {contractor.logo && (
              <img
                src={contractor.logo}
                alt={`${contractor.name} logo`}
                className="h-16 w-16 rounded-lg object-cover"
              />
            )}
            <div>
              <div className="mb-1 text-foreground">{contractor.name}</div>
              <div className="text-muted-foreground">{contractor.location}</div>
            </div>
          </div>

          <div className="mb-6 space-y-3 rounded-lg bg-primary/5 p-4">
            <div className="text-foreground">What happens next:</div>
            <ul className="space-y-2 text-foreground/80">
              <li className="flex gap-2">
                <span>1.</span>
                <span>Your contact information will be shared with {contractor.name}</span>
              </li>
              <li className="flex gap-2">
                <span>2.</span>
                <span>They will contact you within 24 hours to discuss your project</span>
              </li>
              <li className="flex gap-2">
                <span>3.</span>
                <span>Schedule a consultation to get a detailed quote</span>
              </li>
            </ul>
          </div>

          {contractor.availability && (
            <div className="text-muted-foreground">
              Availability: {contractor.availability}
            </div>
          )}
        </div>

        <div className="border-t border-border px-6 py-4">
          <div className="flex gap-3">
            <button
              onClick={onClose}
              disabled={hiring}
              className="rounded-lg border border-border bg-background px-6 py-2 text-foreground hover:bg-accent"
            >
              Cancel
            </button>
            <button
              onClick={onConfirmHire}
              disabled={hiring}
              className="rounded-lg bg-black px-6 py-2 border-0 text-white hover:bg-primary/90"
            >
              {hiring ? "Sending..." : "Confirm & Send Request"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
